export default __webpack_public_path__ + "static/media/account.29f2cb10.svg";